import { MenuOptions } from '../../components/TopBar/TopBar.types'
import { RarumIntlShape } from './pt'

const Styles = (() => {
  try {
    return require('openspace/assets/styles/TextStyles.module.scss')
  } catch (e) {
    return {}
  }
})()

const messages = {
  'en-US': {
    translations: {
      flowRequirements: {
        steps: {
          personalData: {
            title: 'Personal Information',
            questions: {
              name: 'Full Name',
              email: 'Email',
              birthDate: 'Birth date',
              phone: 'Phone',
              document: 'CPF',
              documentForeign: 'Document',
              isForeign: '',
              confirm:
                'I accept sharing my data with <b>({{gallery}})</b> for marketing purposes',
            },
            error: {
              invalidCPF: 'Invalid document',
            },
          },
          address: {
            title: 'Address',
          },
          kyc: {
            title: 'Data validation',
            loading: 'We are validating your data',
            rejected: {
              title: 'Oops, something went wrong',
              description: 'Please check your data carefully and try again',
            },
            approved: {
              title: 'All set!',
              description: 'Your data has been validated!',
            },
            progress: {
              sendingData: 'Starting your data validation',
              waitingReturn:
                'Waiting for data confirmation - you can leave this screen if needed',
            },
          },
        },
        standalone: {
          hi: 'Hello, {{name}}',
          to: {
            claim: {
              title: 'Complete the registration to proceed with the claim',
              action: 'Claim',
              loading: 'Please wait, we are proceeding to the claim',
            },
            'marketplace-buy': {
              title:
                'Complete the following details to proceed with verification',
              action: '$t(generic.continue)',
              loading: 'Please wait',
            },
            'marketplace-sell': {
              title: '$t(flowRequirements.standalone.to.marketplace-buy.title)',
              action:
                '$t(flowRequirements.standalone.to.marketplace-buy.action)',
              loading:
                '$t(flowRequirements.standalone.to.marketplace-buy.loading)',
            },
          },
        },
      },
      forum: {
        postedAt: 'Posted {{time}} ago',
        noItems:
          'Have questions? \nUse the field above and be the first to ask',
        post: {
          placeholder: 'Write your question here',
          cancelConfirmation: 'Do you want to discard the written message?',
          loggedOutUser: 'Hello, login is required to interact',
          actions: {
            cancel: 'Cancel',
            post: 'Post',
          },
        },
        actions: {
          reply: 'Reply',
        },
      },
      offerDetails: {
        goal: 'Goal',
        minInvestment: 'Minimum Investment',
        minInvestmentShort: 'Min. Investment',
        investors: 'Investors',
        reachedPrice: 'Total raised',
        beTheFirstToInvest: 'Be the first to invest',
        receivable: {
          soldUnits: 'Total sold',
          availability: 'Availability',
          expiration: 'Expiration',
          sold: 'Sold',
        },
        cvm: {
          performance: '{{performance}} per year',
          types: {
            equity: 'Equity',
            fixed: 'Fixed income',
            receivable: 'Receivables',
          },
        },
        goalReached: '{{percent}}% of the goal reached',
        goalReached_0: 'No shares reserved at the moment',
        goalReached_beyond: 'Goal achieved',
        sold: '{{percent}}% sold',
        sold_0: 'No sales',
        sold_beyond: 'Goal reached',
        limit: 'Limit',
        timeRemaining: 'TIME REMAINING',
        offer: 'OFFER',
        preMoneyValuation: 'VALUATION',
        companyParticipation: 'company participation',
        sections: {
          ABOUT: 'About the Investment',
          DOCUMENTS: 'Documents',
          KPI: "KPI's",
          FOUNDERS: 'Founders',
          FORUM: 'Forum',
        },
        forum: {
          description:
            'Access the forum to chat and ask questions with other investors and experts',
          posts: 'Posts',
          actions: {
            access: 'Access Forum',
          },
          error: {
            signin: 'You need to be authenticated to view this section',
            cvm: {
              pending:
                'We are reviewing your profile. Please wait. You will receive updates by email.',
              required: 'You need to complete your profile to proceed',
              actions: {
                goToCVM: 'Complete verification',
              },
              rejected:
                'Your profile was not approved. Check your email for more details.',
            },
          },
        },
        actions: {
          invest: 'Invest',
          seeProfile: 'View profile on {{social}}',
          moreInfo: 'More information',
        },
      },
      components: {
        drop: {
          remaining: 'Last item available',
          remaining_plural: '{{count}} items remaining',
          soldout: 'All items have been sold',
        },
        benefits: {
          title: 'Benefits',
          subtitle: 'Check and manage your benefits',
          claim: 'Redeem',
          expired: 'Benefit expired',
          claimed: 'Benefit redeemed',
          claiming: 'Redeeming benefit',
          expireIn: 'Expires in:',
          days_plural: '{{count}} days',
          days: '{{count}} day',
          remaining: '{{count}} item available',
          remaining_plural: '{{count}} items available',
          claimConfirmation: {
            title: 'Redeem benefit',
            actions: {
              claim: 'Redeem benefit',
            },
            success: {
              title: 'Benefit redeemed!',
              description:
                'Soon you will receive instructions and more information about this collection in your registered email {{email}}',
              actions: {
                understood: 'I understand',
              },
              subtitle:
                'Are you sure you want to claim this benefit? <br/>This action cannot be reversed',
              pending:
                'This transaction could take a few minutes. As soon as the claim has been confirmed, you will receive instructions and more information at you registered email <b>{{email}}</b>',
            },
            details: {
              title: 'Benefit details',
              details: 'More details',
              actions: {
                claim: 'Claim benefit',
              },
            },
          },
        },
        form: {
          dataStatus: {
            COMPLETE: 'Completed',
            INCOMPLETE: 'Incomplete',
            PENDING: 'Pending',
            ERROR: 'Error',
          },
        },
        galleryCard: {
          tokenEmitter: {
            totalVolume: 'Total volume',
            projects: '{{count}} project',
            projects_plural: '{{count}} projects',
          },
        },
      },
      generic: {
        knowMore: 'Know more',
        noItemsFound: 'No items found',
        brandMotto: 'This is rare. This is Rarum.',
        waitingAuthorization: 'Waiting for confirmation',
        actions: {
          copy: 'Copy',
        },
      },
      home: {
        banner: {
          v2: {
            brand: 'rarum',
            brandMotto: 'Community Engagement as a Service',
            brandBenefit: 'We appreciate what is rare: your community.',
            actions: {
              features: 'Learn about our Whitelabel platform',
            },
          },
          title: `DIGITAL ASSETS <br/><span class="${Styles.gradient}">SUSTAINABLE AND FOR <br/>EVERYONE</span> `,
          subtitle:
            'Have a digital asset marketplace solution customized for your community',
          action: {
            create: 'Create your store!',
          },
        },
        sections: {
          brand: {
            title: '100% Carbon Neutral',
            description: `We offset all carbon emissions from the platform and traded assets.

Rarum also operates on blockchains that are efficient in their greenhouse gas emissions.`,
          },
          gallery: {
            heading: "Discover the Rarum's galleries",
            title: 'Latest galleries',
            action: {
              seeAll: 'All galleries',
            },
          },
          latest: {
            title: 'Highlighted items',
            action: {
              seeAll: 'All items',
            },
          },
          store: {
            title: 'Stores',
          },
          create: {
            title: 'Create your own store and start selling digital assets.',
            actions: {
              knowMore: 'More info',
            },
            highlight: {
              create: 'Create your own items',
              easy: 'Easy to buy and sell',
              secure: 'Secure, transparent and carbon free',
            },
          },
          partnership: {
            title: 'Carbon Neutral',
            description:
              'In our pursuit of more sustainable practices, we have significantly reduced our carbon emissions and implemented low-impact environmental blockchain technologies.',
            actions: {
              knowMore: 'More info',
            },
          },
          news: {
            title: 'On the news',
          },
          highlights: {
            title: 'Open offers',
          },
        },
      },
      allGalleries: {
        title: 'GALLERIES',
        sections: {
          highlight: {
            title: 'Highlighted galleries',
          },
          createYourOwn: {
            title: 'Create your own store and start selling digital assets!',
            action: {
              knowMore: 'More info',
            },
          },
        },
      },
      myCollection: {
        actions: {
          seeAllGallery: 'See all',
          hideAllGallery: 'Back to list',
        },
      },
      galleryDetails: {
        noMarket: 'Gallery items',
        noAvailable: `Keep watching!
Soon there will be new offers for this gallery`,
        actions: {
          seeAllMarketplace: 'See all on marketplace',
          seeAll: 'See all items',
        },
        expiredItems: 'Closed offers',
        market: 'Marketplace items',
        items: 'Items',
      },
      topbar: {
        menus: {
          [MenuOptions.ABOUT]: 'ABOUT RARUM',
          [MenuOptions.FAQ]: 'FAQ',
          [MenuOptions.GALLERIES]: 'GALLERIES',
          [MenuOptions.MARKET]: 'MARKETPLACE',
          [MenuOptions.HOW_IT_WORKS]: 'HOW IT WORKS',
          [MenuOptions.BRAND]: 'BRANDS',
          [MenuOptions.CREATORS]: 'CREATORS',
        },
        auth: {
          login: 'Sign in',
          signup: 'Sign up',
        },
      },
      offer: {
        creation: {
          steps: {
            value: {
              price: {
                reference: 'Reference price',
                min: 'Minimum price',
                max: 'Maximum price',
              },
              cut: 'Platform cut',
              receive: 'You will receive',
            },
            payment: {
              disclaimer:
                'At the moment, it is only possible to buy and sell on the secondary market using PIX',
              description: 'You receive the amount after delivery is completed',
              pix: {
                title: 'PIX KEY',
                description:
                  'Enter the PIX key where you want to receive the sale amount',
                placeholder: 'CPF, email, phone number, or PIX key',
                disclaimer:
                  'The PIX key provided must belong to the same account holder as confirmed in the financial data',
                error: {
                  invalid:
                    'The key entered does not match the registered CPF. Please check the information and try again.',
                },
              },
            },
            address: {
              title: 'Pickup address',
              description:
                'Confirm or add a return address for shipping the item after purchase',
              actions: {
                addAddress: 'Add address',
              },
            },
            delivery: {
              title: 'Nearest pickup points',
              actions: {
                enableLocation: 'Find nearest',
              },
            },
            deliveryConfirmation: {
              origin: {
                title: "Item's origin address",
                description:
                  'Confirm the origin address and see nearby carriers for shipping the item after purchase',
              },
              postoffices: {
                title: 'Nearby carriers',
                description: 'See the carriers near the provided address',
                action: {
                  seeOnMap: 'View on map',
                },
              },
            },
            confirmation: {
              title:
                "By clicking 'Post Sale', you confirm that you agree to the <b color='secondary'><a href='{{{terms}}}' target='_blank'>terms of service</a></b>",
            },
            creating: {
              title: 'Publishing sale',
              routeChangeWarning: `Your listing hasn't been published yet. If you leave now, the creation process may not be completed.
Are you sure you want to leave?`,
              progress: {
                authorizing: 'Authorizing item transfer',
                creatingOffer: 'Creating offer',
              },
            },
            created: {
              title: 'Sale published successfully!',
              description:
                'Manage and view your listings in the "$t(pages.collections.tab.offers)" area, within the "$t(components.router.tabs.closet)" section',
            },
          },
        },
        buy: {
          steps: {
            address: {
              title: 'Delivery Address',
            },
          },
          loading: "We're preparing your order",
          progress: {
            authorizing: 'Authorizing financial transaction',
            buyingOffer: 'Creating order',
          },
        },
      },
      tracking: {
        total: 'Total',
        number: 'Order Number',
        currentStatusTag: 'Current Status',
        heading: {
          failed: 'Delivery failed',
        },
        status: {
          title: 'Order Status',
          seller: {
            label: {
              AWAITING_POST: '$t(tracking.status.buyer.label.AWAITING_POST)',
              PROCESSED: 'Item shipped',
              IN_TRANSIT: '$t(tracking.status.buyer.label.IN_TRANSIT)',
              OUT_FOR_DELIVERY:
                '$t(tracking.status.buyer.label.OUT_FOR_DELIVERY)',
              DELIVERED: '$t(tracking.status.buyer.label.DELIVERED)',
              FAILED_AWAIT: '$t(tracking.status.buyer.label.FAILED_AWAIT)',
              DELIVERY_FAILED:
                '$t(tracking.status.buyer.label.DELIVERY_FAILED)',
              FAILED_COLLECT: '$t(tracking.status.buyer.label.FAILED_COLLECT)',
              FAILED_CONTACT: '$t(tracking.status.buyer.label.FAILED_CONTACT)',
              FAILED_RETURN: '$t(tracking.status.buyer.label.FAILED_RETURN)',
              PAYED: '$t(tracking.status.buyer.label.PAYED)',
            },
            detail: {
              TRACKING_INFO: '$t(tracking.status.buyer.detail.TRACKING_INFO)',
              TRACKING_N_CONTACT:
                '$t(tracking.status.buyer.detail.TRACKING_N_CONTACT)',
              AWAITING_POST: `You have up to 7 business days to ship the item at the post office.
                
Generate the shipping label and go to the nearest post office to complete the shipment
                
{{generateTrackingBtn}}`,
              PROCESSED: '$t(tracking.status.buyer.detail.PROCESSED)',
              IN_TRANSIT: '$t(tracking.status.buyer.detail.IN_TRANSIT)',
              OUT_FOR_DELIVERY:
                '$t(tracking.status.buyer.detail.OUT_FOR_DELIVERY)',
              DELIVERED: '$t(tracking.status.buyer.detail.DELIVERED)',
              DELIVERY_FAILED: 'We encountered a problem with the delivery.',
              FAILED_COLLECT:
                '$t(tracking.status.seller.detail.DELIVERY_FAILED)',
              FAILED_CONTACT:
                '$t(tracking.status.seller.detail.DELIVERY_FAILED)',
              FAILED_RETURN:
                '$t(tracking.status.seller.detail.DELIVERY_FAILED)',
              FAILED_AWAIT: '$t(tracking.status.seller.detail.DELIVERY_FAILED)',
            },
          },
          buyer: {
            label: {
              AWAITING_POST: 'Awaiting shipment',
              PROCESSED: 'Item shipped by seller',
              IN_TRANSIT: 'Item in transit',
              OUT_FOR_DELIVERY: 'Item out for delivery',
              DELIVERED: 'Item delivered',
              FAILED_AWAIT: 'Delivery attempt failed',
              DELIVERY_FAILED: '$t(tracking.status.label.FAILED_AWAIT)',
              FAILED_COLLECT: '$t(tracking.status.label.FAILED_AWAIT)',
              FAILED_CONTACT: '$t(tracking.status.label.FAILED_AWAIT)',
              FAILED_RETURN: 'Returning to seller',
              PAYED: 'Payment completed',
            },
            detail: {
              TRACKING_INFO:
                '\n\nTracking code:\n{{trackingCode}}\n\n{{trackBtn}}',
              TRACKING_N_CONTACT:
                '\n\nTracking code:\n{{trackingCode}}\n\n{{contactBtn}}',
              AWAITING_POST:
                'Your order has been confirmed!\nThe seller will ship within 7 business days.\n\nYou will receive a notification once the order is shipped.',
              PROCESSED:
                'Estimated delivery: {{- predictedDeliveryDate}}$t(tracking.status.buyer.detail.TRACKING_INFO)',
              IN_TRANSIT: '$t(tracking.buyer.status.detail.PROCESSED)',
              OUT_FOR_DELIVERY: 'Tracking code:\n{{trackingCode}}',
              DELIVERED:
                'Delivered on {{- deliveryDate}}$t(tracking.buyer.status.detail.TRACKING_INFO)',
              DELIVERY_FAILED:
                'Wait for the next delivery attempt, which will be made on the next business day.\nIf the courier is not attended in any of the attempts, the item will be sent to the post office.$t(tracking.buyer.status.detail.TRACKING_INFO)',
              FAILED_COLLECT:
                'Your order is available for pickup at the post office.\nContact the post office for more information.$t(tracking.buyer.status.detail.TRACKING_INFO)',
              FAILED_CONTACT:
                'Something went wrong with your delivery.\nContact our support for more information.$t(tracking.buyer.status.detail.TRACKING_N_CONTACT)',
              FAILED_RETURN:
                'Your order is being returned to the seller.$t(tracking.buyer.status.detail.TRACKING_INFO)',
              FAILED_AWAIT:
                'We encountered a problem with the delivery. We are analyzing it and will provide an update soon.$t(tracking.buyer.status.detail.TRACKING_N_CONTACT)',
            },
          },
          actions: {
            generateLabel: 'Generate shipping label',
          },
        },
        order: {
          details: 'Order Details',
          date: 'Order Date',
          value: 'Item Value',
        },
        help: 'Need help?',
        actions: {
          talkToUs: 'Talk to us',
          track: 'Track shipment',
        },
      },
    },
  },
} satisfies {
  'en-US': RarumIntlShape
}

export default messages
